// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2mMvQ","content":"styles_content__jJm-g","checkbox":"styles_checkbox__dL-9P","checkboxLabel":"styles_checkboxLabel__1-td6"};